export default __webpack_public_path__ + "static/media/397.b77aa6ce.gif";